import React, { useState } from 'react';

import SignInForm from '../Forms/SignIn';
import SignUpForm from '../Forms/SignUp';
import RecoverAccountForm from '../Forms/RecoverAccount';
import { useSelector } from 'react-redux';

const Authentication = () => {

  const appProps = useSelector(store => store.app),
        modalProps = useSelector(store => store.modal),
        [formType, setFormType] = useState(modalProps.defaultAuthenticationForm);
 
  return (
    <>
      {
        !appProps.isUserAuthenticated &&
        formType === 'signIn' &&
        <>
          <h3 className="modal__header">Sign In</h3>

          <SignInForm recoverPasswordEvent={ () => setFormType('recover') } signUpEvent={ () => setFormType('signUp') } />
        </>
      }

      {
        formType === 'signUp' &&
        <>
          <h3 className="modal__header">New User</h3>

          <SignUpForm recoverPasswordEvent={ () => setFormType('recover') } signInEvent={ () => setFormType('signIn') } />
        </>
        
      }

      {
        !appProps.isUserAuthenticated &&
        formType === 'recover' &&
        <>
          <h3 className="modal__header">Forgot your Password?</h3>

          <RecoverAccountForm signInEvent={ () => setFormType('signIn') } signUpEvent={ () => setFormType('signUp') } />
        </>
      }
    </>
  );

}

export default Authentication;